import React from 'react';

import { Text } from '@betterment/samba-react';
import { Button, Modal, theme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import { OPS_LOCKED_EMAIL } from '../../Shared/constants';

const SupportLink = styled.a`
  text-decoration: underline;
  color: ${theme.colors.bmtBlue} !important;
`;

interface Props {
  closeHandler: () => void;
}

const LockedAccountModal: React.FC<React.PropsWithChildren<Props>> = ({ closeHandler }) => {
  return (
    <Modal contentWidth={['100%', '600px']} closeHandler={closeHandler}>
      <Modal.Slot name="heading">Your Checking account is currently locked</Modal.Slot>
      <Modal.Slot name="content">
        <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
          Please contact us at <SupportLink href={`mailto:${OPS_LOCKED_EMAIL}`}>{OPS_LOCKED_EMAIL}</SupportLink> to
          resolve. You won't be able to take action on your Checking account until we unlock it.
        </Text>
      </Modal.Slot>
      <Modal.Slot name="actions">
        <Button onClick={closeHandler}>Got it</Button>
      </Modal.Slot>
    </Modal>
  );
};

export default LockedAccountModal;
